/**
 * Madesa Account Modal
 * Handles the account login/actions modal functionality
 */

class MadesaAccountModal {
  constructor() {
    this.modal = document.querySelector('[data-account-modal]');
    if (!this.modal) return;

    this.overlay = this.modal.querySelector('[data-account-overlay]');
    this.closeBtn = this.modal.querySelector('[data-account-close]');
    this.triggers = document.querySelectorAll('[data-account-trigger]');
    
    this.init();
  }

  init() {
    // Open modal on trigger click
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close modal on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Close modal on close button click
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Close modal on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('active');
    this.modal.classList.remove('madesa-hidden');
    // Only hide overflow if mobile menu is not open
    if (!document.body.classList.contains('madesa-mobile-menu-open')) {
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    this.modal.classList.remove('active');
    this.modal.classList.add('madesa-hidden');
    // Only restore overflow if mobile menu is not open
    if (!document.body.classList.contains('madesa-mobile-menu-open')) {
      document.body.style.overflow = '';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MadesaAccountModal();
  });
} else {
  new MadesaAccountModal();
}
